import { Injectable } from "@angular/core";

import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  CanLoad,
  Route,
} from "@angular/router";
import "rxjs/add/operator/toPromise";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    // Imaginary method that is supposed to validate an auth token and return a boolean
    if (localStorage.getItem("authToken") || localStorage.getItem("email")) {
      return true;
    } else {
      this.router.navigate(["/authentication/sign-in"]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/authentication.service.ts